import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M15 3v4a1 1 0 0 0 1 1h4","key":"svg-1"}],["path",{"d":"M6 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7","key":"svg-2"}],["path",{"d":"M3 15l3 -3l3 3","key":"svg-3"}]]

const IconFileIsr = createReactComponent('outline', 'file-isr', 'FileIsr', __iconNode);

export default IconFileIsr;